// Englische Fassung von ../de/projects.ts.
//
// „My SOPs" wird NICHT übersetzt (Produkt-/Lookup-Name, s. de/projects.ts).
import type { ProjectsKatalog } from "../de/projects";

export const projects: ProjectsKatalog = {
  spalten: {
    open: "Open",
    in_progress: "In progress",
    done: "Done",
  },

  // Empty state / creating
  projektWaehlen: "Pick a project from the sidebar on the left.",
  deineProjekte: "Your projects",
  eigeneOderNeu: (n: number) => `${n} of your own · or create a new one.`,
  neuesProjektPlatzhalter: "New project …",
  neuesProjektAnlegen: "Create new project",
  projektAngelegt: "Project created",

  // Header
  inSalesforceOeffnen: "Open in Salesforce",
  aufgabe: "Task",
  kontext: "Context",
  kontextTitel: "Show instructions & knowledge",
  projektAktionen: "Project actions",
  projektLoeschen: "Delete project",

  // Workstreams
  alle: "All",
  ohneWorkstream: "No workstream",
  workstream: "Workstream",
  workstreamAktionen: (name: string) => `Actions for workstream ${name}`,
  workstreamLoeschenFrage: (name: string) => `Delete workstream “${name}”?`,
  workstreamLoeschenHinweis:
    "Only empty workstreams can be deleted. As long as tasks, handoffs or an " +
    "active session lock still hang off it, the server declines and names what " +
    "is blocking.",
  workstreamLoeschenFehlgeschlagen: "Could not delete workstream",

  // Kanban
  leer: "(empty)",
  aufgabeHinzufuegen: "+ Task",
  salesforceReadOnly: "Salesforce (read-only)",
  ueberfaellig: "overdue",
  brauchtEntscheidung: "Needs a decision",
  wartetAufAntwort: "Waiting for an answer",
  oeffnen: "open",
  statusNichtGeaendert: "Could not change the status",

  // Deleting a project
  projektLoeschenFrage: (name: string) => `Delete project “${name}”?`,
  loeschenLaeuft: "Deleting …",
  endgueltigLoeschen: "Delete permanently",
  loeschHinweisDauerhaft:
    "The project will be removed permanently. This action cannot be undone.",
  loeschHinweisAlle: "All",
  phasenWorkstreams: "phases/workstreams",
  loeschHinweisRest:
    "of this project are deleted with it. Tasks and notes are kept, but lose their project assignment.",
  projektGeloescht: "Project deleted",
  loeschenFehlgeschlagenPunkt: "Deletion failed.",
  loeschenFehlgeschlagenMit: (fehler: string) => `Deletion failed: ${fehler}`,

  // Artefacts / presentations
  neuesArtefakt: "New artefact",
  praesentation: "Presentation",
  praesentationBeschreibung:
    "Multi-page PPTX with an agent pipeline (outline → slides → render)",
  blog: "Blog",
  blogArtikel: "Blog article",
  blogArtikelBeschreibung:
    "Coming soon — TOC → sections, based on knowledge + external sources",
  video: "Video",
  heygenVideo: "Heygen video",
  heygenVideoBeschreibung:
    "Coming soon — scenes with avatars are derived from a blog article",
  keineArtefakte: "No artefacts yet. Click “New artefact” above.",
  keineTrefferFilter: "No matches for this filter.",
  blogAgentFehlt: "The blog article agent is not built yet (phase 4 — planned after Monday).",
  videoAgentFehlt:
    "The Heygen video agent is not built yet (phase 5 — needs the marketing API extension).",
  praesentationLoeschenFrage: (titel: string) => `Delete presentation “${titel}”?`,
  vorschauOeffnen: "Open preview",
  slides: (n: number) => (n === 1 ? "1 slide" : `${n} slides`),
  preview: "Preview",
  pptxHerunterladen: "Download PPTX directly",
};
